import { css } from "@emotion/react";
import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import Switch, { SWITCH_SIZES } from "components/DesignComponents/Switch";
import { body1SemiBold } from "shared";

import { SingleCookieItemProps } from "../types";

export const SingleCookieItem = ({
    cookieDescription,
    cookieTitle,
    isItemSeparator,
    switcherLabel,
    toggleDisable,
    toggleChecked,
    onToggleChange,
    customStyle
}: SingleCookieItemProps) => {
    const { gray300, gray700 } = colors;

    return (
        <>
            <div
                css={css(
                    {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    },
                    customStyle
                )}
            >
                <div
                    css={[body1SemiBold, { color: gray700, maxWidth: "484px" }]}
                >
                    {cookieTitle}
                </div>

                <Switch
                    size={SWITCH_SIZES.Medium}
                    defaultChecked={toggleChecked}
                    disabled={toggleDisable}
                    labelLeft={switcherLabel}
                    onChange={onToggleChange}
                />
            </div>
            <div
                css={css({
                    borderBottom: isItemSeparator
                        ? `1px solid ${gray300}`
                        : "unset"
                })}
            >
                <Typography
                    variant="body2"
                    css={css({
                        marginTop: "8px",
                        marginBottom: isItemSeparator ? "24px" : "unset",
                        lineHeight: "20px",
                        letterSpacing: "0.1px",
                        color: gray700
                    })}
                >
                    {cookieDescription}
                </Typography>
            </div>
        </>
    );
};
